module.exports = __webpack_public_path__ + "static/media/contentlink.4f8a54e6.svg";